import React from "react";
import useCopyToClipboard from "../../common/useCopyToclipboard";
import { useQuery } from "react-query";
import { loadApplication } from "../../../queries/consumer/application";
import { useErrorHandler } from "react-error-boundary";
import { matchPath } from "react-router-dom";
import AppSettings from "./AppSettings";
import PropTypes from "prop-types";
import FinstreamVFTab from "./FinstreamVFTab";
import OverviewTab from "./OverviewTab";
import FinstreamDsTab from "./finstreamDSTab";
import FinscoreFsTab from "./FinscoreFSTab";
import FinscoreQsTab from "./FinscoreQSTab";

const ApplicationPage = ({ queryClient, currentUser, toast, cableApp }) => {
  const [isCopied, handleCopy] = useCopyToClipboard(3000);
  const handleError = useErrorHandler();
  const applicationId = matchPath(location.pathname, {
    path: "/applications/:id",
    exact: true,
  })?.params.id;

  const {
    isLoading,
    isError,
    data: application,
  } = useQuery(
    ["application", applicationId],
    async () => await loadApplication(applicationId, true),
    {
      enabled: !!applicationId,
    }
  );

  return (
    <div className="container">
      {application && !isLoading && (
        <>
          <h3>{application.name}</h3>
          <div className="collapse show" id="api-info">
            <div className="py-3">
              <hr className="mt-0 mb-4" />
              <p className="mb-4">
                To learn how to use the following keys, please consult our{" "}
                <a
                  className="link-color"
                  href="https://developer.finclude.xyz"
                  target="_blank"
                  rel="noreferrer"
                >
                  developer documetantion
                </a>
                .
              </p>
              <div className="d-flex flex-wrap">
                <div className="mb-3 pr-2">
                  <label className="d-block pl-3 label-sm">CLIENT ID</label>
                  <span className="code-wrapper mb-3">
                    <code>{application.clientId}</code>
                    <a href="#">
                      <i
                        className="cp-icon"
                        onClick={() => handleCopy(application.clientId)}
                      />
                    </a>
                  </span>
                </div>
                <div className="mb-3 pr-2">
                  <label className="d-block pl-3 label-sm">CLIENT SECRET</label>
                  <span className="code-wrapper mb-3">
                    <code>{application.clientSecret}</code>
                    <a href="#">
                      <i
                        className="cp-icon"
                        onClick={() => handleCopy(application.clientSecret)}
                      />
                    </a>
                  </span>
                </div>
                <div className="mb-3 pr-2">
                  <label className="d-block pl-3 label-sm">PROVISION ID</label>
                  <span className="code-wrapper mb-3">
                    <code>{application.provisionKey}</code>
                    <a href="#">
                      <i
                        className="cp-icon"
                        onClick={() => handleCopy(application.provisionKey)}
                      />
                    </a>
                  </span>
                </div>
              </div>
              <hr className="mt-3 mb-0" />
            </div>
          </div>
          <a
            className="text-small link-color mt-n3"
            data-toggle="collapse"
            href="#api-info"
            aria-expanded="true"
          >
            {/*<span style="display:inline-block;width:8px;height:8px;border-left:2px solid currentColor;border-top:2px solid currentColor;transform:rotate(45deg);margin-right:.5rem"></span> */}
            API info
          </a>

          <ul className="nav nav-pills mx-n2 my-5" role="tablist">
            <li className="nav-item mb-2">
              <a
                className="nav-link active"
                data-toggle="tab"
                href="#overview"
                role="tab"
              >
                Overview
              </a>
            </li>
            {/* {application.apiProducts.includes("finstreamvf") && (
              <li className="nav-item mb-2">
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#finstreamvf"
                  role="tab"
                >
                  FinstreamVF
                </a>
              </li>
            )}

            {application.apiProducts.includes("finstreamds") && (
              <li className="nav-item mb-2">
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#finstreamds"
                  role="tab"
                >
                  FinstreamDS
                </a>
              </li>
            )}

            {application.apiProducts.includes("finscorefs") && (
              <li className="nav-item mb-2">
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#finscorefs"
                  role="tab"
                >
                  FinscoreFS
                </a>
              </li>
            )}

            {application.apiProducts.includes("finscoreqs") && (
              <li className="nav-item mb-2">
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#finscoreqs"
                  role="tab"
                >
                  FinscoreQS
                </a>
              </li>
            )} */}

            <li className="nav-item mb-2">
              <a
                className="nav-link"
                data-toggle="tab"
                href="#settings-users"
                role="tab"
              >
                App settings & users
              </a>
            </li>
          </ul>

          <div className="tab-content d-flex flex-column flex-lg-row">
            <OverviewTab
              cableApp={cableApp}
              currentUser={currentUser}
              application={application}
            />
            {/* {application.apiProducts.includes("finstreamvf") && (
              <FinstreamVFTab cableApp={cableApp} application={application} />
            )}
            {application.apiProducts.includes("finstreamds") && (
              <FinstreamDsTab cableApp={cableApp} application={application} />
            )}
            {application.apiProducts.includes("finscorefs") && (
              <FinscoreFsTab cableApp={cableApp} application={application} />
            )}
            {application.apiProducts.includes("finscoreqs") && (
              <FinscoreQsTab cableApp={cableApp} application={application} />
            )} */}
            <AppSettings
              queryClient={queryClient}
              application={application} 
              currentUser={currentUser}
              toast={toast}
            />
          </div>
        </>
      )}
    </div>
  );
};

ApplicationPage.propTypes = {
  currentUser: PropTypes.object.isRequired,
};

export default ApplicationPage;
